import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Confirm from '@fuse/core/FuseDialog/confirm';
import { openDialog } from 'app/store/fuse/dialogSlice';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import { Button, Tooltip, CircularProgress, Backdrop } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import _, { capitalize, lowerCase, upperCase } from 'lodash';
import dispatchMessage, { checkNullOrUndefined, isCustomer, isSupplier, isVasTeam } from 'app/main/apps/common/AuraFunctions';
import { openReallocationDialog, deleteShipment, getStoneOrder } from 'app/main/apps/e-commerce/store/ordersSlice';
import { selectActions, selectUser } from 'app/store/userSlice';
import { convertToOrder, getOrderDetails, downloadOrderPdf, getQuotedSuppliers, openChooseSupplierDialog, openSupplierShippingDialog, performAction, updateOrder, getAdvancePayment, getBriefInvoiceDetails, sendEmail, getComments, showDialog, sendReminderEmail } from 'app/main/apps/e-commerce/store/orderSlice';
import { openProductDialog } from 'app/main/apps/e-commerce/store/productSlice';
import { getSentToSuppliers, getSuppliers } from 'app/main/apps/e-commerce/store/rfqsSlice';
import { showMessage } from 'app/store/fuse/messageSlice';
import { getOpenContainers } from 'app/main/apps/backoffice/store/shipmentOrderSlice';
import downloadFile from 'app/main/apps/common/AuraDownload';
import { getApiErrorMessage } from 'app/utils/apiError';
import { useFormContext } from 'react-hook-form';
import { rejectRfqQuote } from 'app/main/apps/e-commerce/store/rfqSlice';
import showConfirmationDialog from 'app/main/apps/common/AuraSimpleConfirmDialogs';
import { openViewOrderDialog, closeViewOrderDialog, getEcomWidgetsOrderItems, viewNote, getShipmentInfo } from '../store/widgetsSlice';
import MenuActions from '../dialogs/MenuActions';
import { getNoteRedirect } from './noteRedirect';
import { isArchivedView } from 'app/main/apps/common/archivedRecord';
import {
  buildInlineDocumentsPayload,
  firstClickPopupAction,
  isViewAction,
  opensApprovalDialogFromPopup,
  splitPopupActions,
} from 'app/main/apps/common/popupActions';

function OpenOrdersRowAction({
  order,
  stage,
  orderId,
  isManage,
  loadOrders,
  orderData,
  popupButtons,
  closeDialog = undefined,
  type = undefined,
  approveProof,
  listData,
  selectedImages,
  popupData,
  renderActions,
}) {
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  // PGSS-5471: a first-click popup action is running -- its buttons are disabled so a second click cannot send twice.
  const [popupActionRunning, setPopupActionRunning] = useState(false);
  const dispatch = useDispatch();
  const allaActions = useSelector(selectActions);
  const user = useSelector(selectUser);
  const stageAction = allaActions.filter((action) => action.stage === stage);
  let actions = stageAction.find((action) =>
    (action.fromStatusesTypeCode === order.status.system_code) && action.fromStatusesTypeCode)?.actionList[0];

  const methods = useFormContext()
  const { setError, getValues } = methods || {}

  if (actions) actions = JSON.parse(actions).filter((action) => action.dashboardAction === true);
  if (type && actions) actions = actions.filter(el => !(['cancel', 'visibility', 'alarm'].includes(el.icon)))

  if (order?.is_stone_order && !order?.is_proof_approval && actions) {
    actions = actions.filter(el => el.name !== 'Create Supplier Order')
  }
  if (!order?.is_stone_order && order?.is_proof_approval && actions) {
    actions = actions.filter(el => el.name !== 'Create Stone Order')
  }
  if (stage === "order" && (order.order_type === "DS" || order.order_type === "Direct Shipment" || order.order_type === "DP" || order.order_type === "Direct Pickup") && actions) {
    actions = actions.filter(el => el.name !== 'Receive Order')
  }
  const showRejectQuote = stage === 'quote' && popupButtons && popupData && popupData?.name === "Review Quote" && isManage;
  const isReviewActions = stage === 'order' && popupButtons && popupData && (popupData?.parentParam?.uiId === "REVIEW_DRAWING_ORDER" || popupData?.parentParam?.uiId === "REVIEW_DRAWING") && isManage;

  // PGSS-5453: `count`/`showMore` are gone -- see popupActions.js. They capped the popup at three
  // actions while counting one list and indexing the overflow menu into another.
  const maxCount = showRejectQuote ? 4 : 3;
  const key = stage === 'invoice' ? 'invoice_id' : 'oid'
  const allowActions = [
    'EDIT_ORDER',
    'EDIT_QUOTE',
    'VIEW_ORDER',
    'VIEW_QUOTE',
    'CONVERT_TO_QUOTE',
    'CONVERT_TO_PROOF',
    'EDIT_RFQ',
    'VIEW_RFQ',
    'EDIT',
    'SHIPMENT_PRINT',
    'EDIT_SHIPMENT',
    'PRINT_PRODUCTION',
    'STATUS_UPDATE',
    'REVISE_QUOTE',
    'REVIEW_NOTE',
    'VIEW_SUPPLIER_INVOICE',
    'SUBMIT_VAS_PROOF',
    'VAS_PROOF_INPROGRESS',
    'REQUEST_INFORMATION',
    'REVIEW_PROOF',
    'READY_FOR_PLOTTING',
    'IN_SANDBLASTING',
    'IN_LASER_ETCHING',
    'READY_SEND_FOR_VAS_APPROVAL',
    'REVIEW_VAS',
    'ATTACH_DRAWING',
    'UPLOAD_IMAGE',
    'APPROVE_PRODUCT_IMAGE',
    'REVISE_PRODUCT_IMAGE',
    'EDIT_SUPPLIER_QUOTE'
  ];

  const basedOnImageCustomzation = () => {
    let Key = ''
    if (orderData.image_customisation) {
      Key = 'update_status_with_attachment'
    }
    else {
      Key = 'updateStatus'
    }
    return Key
  }

  const getTitle = () => {
    if (['in-production', 'fulfilled', 'confirmed'].includes(stage)) {
      return 'order'
    }
    if (stage === 'completed') return 'rfd'
    return stage
  }

  const buildSelectedDrawing = (selectedImagesData, fullDetails) => {
    if (fullDetails?.length === 0) return []
    return fullDetails.map((detail, index) => {
      const selectedDocs = selectedImagesData[index] || [];
      const selectedDocIds = selectedDocs.map(doc => doc.id);

      const filteredDocuments = detail?.drawing_documents?.filter(doc => selectedDocIds.includes(doc.id));
      return {
        ...detail,
        vas: detail?.vas ? JSON.stringify(detail.vas) : null,
        drawing_documents: filteredDocuments
      };
    });
  };


  const confirmation = (toStatusCode, id, otherPayload = {}, code, approvalPayload) => {
    if(id === "SEND_ORDER_FOR_DRAWING_APPROVAL") {
      // Disable the SEND_ORDER_FOR_DRAWING_APPROVAL button once it is clicked
      // Currently disable button is handled only for SEND_ORDER_FOR_DRAWING_APPROVAL
      setIsSubmitted(true)
    }
    let action;
    const performApi = ['MAKE_IN_PROGRESS', 'CANCEL_INVOICE', 'SEND_REMINDER', 'RFQ_REMINDER', 'UPLOAD_DOCUMENT'].includes(id)
    const isApproval = !performApi && !['RECEIVE_ORDER', 'STATUS_UPDATE', 'REJECT_QUOTE', 'SEND_ORDER_FOR_DRAWING_APPROVAL'].includes(id)
    const isSupplierRejectQuote = id === 'REJECT_QUOTE' && isSupplier(user.role);
    if(isSupplierRejectQuote)
      action = dispatch(
        rejectRfqQuote({
          id: orderId,
          note: otherPayload?.note
        })
      )
    else if (performApi)
      action = dispatch(performAction({
        ui_id: id,
        data: {
          [id === 'UPLOAD_DOCUMENT' ? 'shipment_id' : 'id']: orderId,
          ...(id === 'UPLOAD_DOCUMENT' && { orders: [...approvalPayload] })
        },

      }));
    else
      action = dispatch(
        updateOrder({
          id: orderId,
          to_statuses_type_id: code || toStatusCode,
          [isApproval ? 'update_status_with_attachment' : basedOnImageCustomzation()]: 'yes',
          ...otherPayload
        })
      )
    // PGSS-5471: returned so a first-click popup action can re-enable its buttons when the request ends.
    return action.then((res) => {
      if(id === "SEND_ORDER_FOR_DRAWING_APPROVAL") {
        setIsSubmitted(false)
      }
      if (!res.error) {
        dispatch(showMessage({ type: 'success', message: 'Success' }));
        if (loadOrders) {
          loadOrders();
        }
        dispatch(closeViewOrderDialog());
      } else {
        // PGSS-5613: a rejected thunk carries the backend's error body in `payload`, not on the action itself.
        throw new Error(getApiErrorMessage({ response: { data: res.payload ?? res } }, 'Failed to update'));
      }
    }).catch((error) => {
      dispatch(showMessage({ type: 'error', message: error.message }));
      if(id === "SEND_ORDER_FOR_DRAWING_APPROVAL") {
        setIsSubmitted(false)
      }
    });
  };

  const defaultAction = [
    {
      dashboardAction: true,
      icon: "preview",
      name: `View ${stage === 'completed' ? upperCase(getTitle()) : capitalize(getTitle())}`,
      to_statuses_types_code: "",
      to_statuses_types_id: "",
      ui_id: `VIEW_${upperCase(getTitle())}`,
    }
  ]

  const paramForSupplier = ['art/design', 'stone']
  const workFlowAction = ['Send to Supplier for Proof', 'Send to Supplier']


  const checkData = (data) => {
    let validProduct = true;
    data.every((product) => {
      if (!product.color || !product.type || !product.length || !product.width || !product.height) {
        validProduct = false;
      }
      return null;
    })

    return validProduct;

  }

  const getApprovalResetData = (data, showDocuments = false) => {
    const resetData = { order_details: [] }
    data?.forEach((item) => {
      resetData.order_details.push(
        {
          id: item.id,
          vas: item.vas,
          showDocuments
        }
      )
    })
    return resetData
  }

  const exportShipment = (isPrice) => {
    return (
      downloadFile({ params: { id: orderId, is_price: isPrice }, endPoint: '/api/exportShipment' })
        .then(() => {
          dispatch(showMessage({ type: 'success', message: 'File downloaded successfully' }))
          dispatch(closeViewOrderDialog({ field: 'orderDialog', }))
        })
        .catch(() => dispatch(showMessage({ type: 'error', message: 'Failed to download' })))

    )
  }

  const additionalButton = () => {
    return (
      <div className='flex gap-10'>
        <Button
          variant="contained"
          color="secondary"
          type="button"
          onClick={() => { exportShipment(true) }}
        >
          Export Shipment With Price
        </Button>
        <Button
          variant="contained"
          color="secondary"
          type="button"
          onClick={() => { exportShipment(false) }}
        >
          Export Shipment Without Price
        </Button>
      </div>
    )
  }

  const reviewOrder = (data, isEdittableView) => {
    const edittableData  = isEdittableView === true ? ["reference_no", "decedent", "comments"] : [];
    dispatch(
      openViewOrderDialog({
        completeOrderData: orderData,
        data: data?.payload || [],
        param: {
          name: 'Review',
          type: 'View',
          title: `Review ${capitalize(getTitle())}`,
          showDialogActions: !isManage ? true : null,
          loadOrders,
          edittableData,
          resetFormOrderDetails: isEdittableView,
          noDocumentsInForm: isEdittableView,
          passExtraPayload: isEdittableView,
          setUpdateOrderDetailsFlag: isEdittableView,
        },
        stage,
      })
    );
  }

  const handleClick = (id, toStatusCode, name, toStatusId) => {
    switch (id) {
      case 'APPROVAL_REMINDER':
        setLoading(true);
        dispatch(sendReminderEmail({id:getDetails().widgetId, params: {stage}})).then((sendReminderEmailResponse) => {
          if (!sendReminderEmailResponse?.error) {
            dispatch(showMessage({ type: 'success', message: 'Reminder email sent successfully' }));
          }
        })
        .finally(() => setLoading(false));
        break;
      case 'REQUEST_REVISION_SUPPLIER_DRAWING':
        setLoading(true);
        dispatch(getOrderDetails(({ id: orderData.id, params: {} })))
          .then(({ payload }) => {
            if (payload) {
              dispatch(
                openViewOrderDialog({
                  completeOrderData: orderData,
                  data: payload,
                  param: {
                    name: 'approveActions',
                    maxWidth: 'md',
                    showHeader: true,
                    showLatestRevisionNote: true,
                    chooseRevisionDocuments: true,
                    showUploadRevisionDocuments: true,
                    title: name,
                    successMessage: 'Revision Requested Successfully',
                    loadOrdersFun: loadOrders,
                    data: {
                      uiId: id, toStatusCode
                    },
                    showAutoNote: true, // Set this field for schema creation and display AutoNote field section in NoteFormCOntent
                    noteFieldName: "revision_note", // Set this field for note field_name that will be sent to BE
                    noteErrorMessage: "Notes is Required", // Set this field for incase of error
                    noteFieldLabelName: "Notes", // Set this field for display Label name
                  },
                  stage,
                  field: 'orderDialog',
                })
              );
            }
            setLoading(false);
          }
        );
        break;
      case 'REVIEW_DRAWING':
      case 'REVIEW_DRAWING_ORDER':
        // REVIEW_DRAWING_ORDER -> Order drawing review to approve or request revision
        // REVIEW_DRAWING -> After supplier subitted drawing "Review Drawing" action will display in the table.
        // REVIEW_DRAWING -> Order drawing review to Send drawing for approval(customer approval), approve or request revision
        setLoading(true);
        dispatch(getEcomWidgetsOrderItems({ [key]: orderData.id, stage })).then(
          (data) => {
            if (data && data.payload) {
              dispatch(
                openViewOrderDialog({
                  completeOrderData: orderData,
                  data: data.payload,
                  param: {
                    name,
                    type: 'View',
                    title: name,
                    showDialogActions: true,
                    hideDialogActions: true,
                    uiId: id,
                    loadOrdersFun: loadOrders,
                    loadOrders
                  },
                  stage,
                })
              );
            }
            setLoading(false);
          }
        );
        break;
      case 'INTERNAL_COMMENTS': {
        const commentsParam = { order_id: orderData?.id };
        const title = `${name} - ${_.capitalize(stage)} No: ${orderData.order_no}`
        if(orderData?.id) {
          setLoading(true);
          dispatch(getComments(commentsParam)).then((res) => {
            if (!res.error) {
              setLoading(false);
              dispatch(
                openViewOrderDialog({
                  completeOrderData: orderData,
                  data: orderData,
                  param: {
                      name: 'notesHistory',
                      title,
                      maxWidth: 'md',
                      notesData: res?.payload || [],
                      noteFieldName: 'comments',
                      noteFieldLabelName:'Comments',
                      addNote: true,
                      showNoteHistory: true,
                      successMessage: 'Success',
                      submitButtonName: 'Submit',
                      purpose: "customerComments",
                    },
                  field: 'orderDialog',
                  stage,
                })
              );
            }
          });
        }
      }
      break;
      case 'STONE_ORDER_STATUS_CHECK':
        dispatch(getStoneOrder(orderData.id)).then((res) => {
          if (!res.error) {
            dispatch(
              openViewOrderDialog({
                completeOrderData: res?.payload,
                data: res?.payload?.order_details || [],
                param: {
                  name,
                  type: 'View',
                  title: name,
                  hideAmountDetails: true,
                  showNameField: true,
                  showDialogActions: false,
                },
                stage,
              })
            );
          } else if(res?.error && res?.error?.code === "ERR_BAD_REQUEST") {
            // Inventory order does not have the stone order. But currently we are displaying the Icon
            // SO, Added code here to show the message
            dispatchMessage(dispatch, 'Stone Order Record Not Found', 'info');
          }
        });
      break;
      case 'ADD_NOTE':
        dispatch(
          openViewOrderDialog({
            completeOrderData: orderData,
            data: { id: orderId },
            param: {
              name: 'note',
              title: 'Add Note',
              successMessage: 'Your note has been sent successfully',
            },
            field: 'orderDialog',
            stage
          })
        );
        break;
        case 'CANCEL_ORDER':
          dispatch(
            openViewOrderDialog({
              completeOrderData: orderData,
              data: { id: orderId },
              param: {
                name: 'rejectQuote',
                title: name,
                submitButtonName: name,
                onSubmit: ({ note }) => {
                  confirmation(toStatusCode, id, { note })
                }
              },
              field: 'orderDialog',
              stage
            })
          );
      break;
      case 'DELETE_SHIPMENT':
        dispatch(
          openDialog({
            children: (
              <Confirm title="Delete Shipment"
                content="Are you sure you want to permanently delete this item"
                onSubmit={() => {
                  setLoading(true);
                  dispatch(deleteShipment(
                    orderData.shipment_id,
                  )).then(res => {
                    setLoading(false);
                    if (!res.error) {
                      dispatch(showMessage({ message: "Selected item has been deleted successfully", type: 'success' }))
                      loadOrders()
                    }
                  })
                }}
              />
            ),
          })
        );
        break;
      case 'DOWNLOAD':
        setLoading(true)
        dispatch(downloadOrderPdf(({ id: orderId, stage, orderNo: orderData?.order_no })))
          .finally(() => setLoading(false));
        break;
      case "SEND_EMAIL":
        setLoading(true);
        dispatch(sendEmail(orderId))
          .then((sendEmailResponse) => {
            if (sendEmailResponse?.payload?.order) {
              dispatch(
                showMessage({
                  type: "success",
                  message: "Email sent successfully",
                })
              );
            }
          })
          .finally(() => setLoading(false));
        break;
      case 'QUICK_EDIT':
        setLoading(true);
        dispatch(getOrderDetails(({ id: orderId, params: {} }))).then(({ payload }) => {
          dispatch(openViewOrderDialog({
            completeOrderData: orderData,
            data: payload,
            param: {
              name: 'edit_order',
              title: `Edit ${stage.replace(/^\w/, (c) => c.toUpperCase())} (Basic Info)`,
              successMessage: 'Success',
              submitButtonName: 'Save',
              loadOrdersFun: loadOrders,
            },
            field: 'orderDialog',
            stage
          }))
        }).finally(() => {
          setLoading(false);
        })
        break;
      case 'CONFIRM_INVOICE':
        if (isSupplier(user.role) && stage === 'invoice') {
          dispatch(
            openViewOrderDialog({
              data: { id: orderData?.shipment_id },
              param: {
                loadOrdersFun: loadOrders,
              },
              field: 'confirmInvoiceDialog',
              stage
            })
          )
        } else {
          setLoading(true);
          dispatch(getBriefInvoiceDetails({ id: orderData.id }))
            .unwrap()
            .then((payloadData) => {
              const merged = { ...payloadData, id: orderData.id };
              dispatch(
                openViewOrderDialog({
                  completeOrderData: orderData,
                  data: merged,
                  param: {
                    name: 'confirm_invoice',
                    title: 'Confirm Invoice',
                    maxWidth: payloadData?.discrepancy?.warning_active ? 'md' : 'sm',
                    successMessage: 'Invoice has been confirmed and sent to the customer',
                    loadOrdersFun: loadOrders,
                  },
                  field: 'orderDialog',
                  stage,
                })
              );
            })
            .catch(() => {
              dispatchMessage(dispatch, 'Unable to load invoice details', 'error');
            })
            .finally(() => setLoading(false));
        }
        break;
      case 'UPDATE_INVOICE':
        dispatch(getBriefInvoiceDetails({ id: orderData.id })).then((data) => {
          const payloadData = data.payload;
          payloadData.id = orderData.id;
          dispatch(
            openViewOrderDialog({
              completeOrderData: orderData,
              data: payloadData,
              param: {
                name: 'update_invoice',
                title: 'Update Invoice',
                maxWidth: payloadData?.discrepancy?.warning_active ? 'md' : 'sm',
                successMessage: 'Invoice has been updated and sent to the customer',
                loadOrdersFun: loadOrders,
                isSupplierInvoice: type === 'supplier-invoices' || type === 'Supplier Invoice',
              },
              field: 'orderDialog',
              stage
            })
          )
        })
        break;
      case 'REVIEW_INVOICE_DISCREPANCY':
        setLoading(true);
        dispatch(getBriefInvoiceDetails({ id: orderData.id }))
          .unwrap()
          .then((payloadData) => {
            dispatch(
              openViewOrderDialog({
                completeOrderData: orderData,
                data: { ...orderData, ...payloadData, id: orderData.id },
                param: {
                  name: 'review_invoice_discrepancy',
                  title: 'Review discrepancy',
                  maxWidth: payloadData?.discrepancy?.warning_active
                    || payloadData?.discrepancy?.latest_decision
                    ? 'md'
                    : 'sm',
                  hideDialogActions: true,
                  loadOrdersFun: loadOrders,
                },
                field: 'orderDialog',
                stage,
              })
            );
          })
          .catch(() => {
            dispatchMessage(dispatch, 'Unable to load invoice details', 'error');
          })
          .finally(() => setLoading(false));
        break;
      case 'VIEW_NOTE':
        dispatch(viewNote({ id: orderData.id })).then((data) => {
          dispatch(
            openViewOrderDialog({
              completeOrderData: orderData,
              data: data.payload,
              param: {
                name: 'note',
                title: 'View Note',
              },
              field: 'orderDialog',
              stage
            })
          );

        })
        break;
        case 'INTERNAL_NOTES': {
          const details = getDetails();
          dispatch(
            openViewOrderDialog({
              completeOrderData: orderData,
              data: orderData,
              param: {
                name: 'internalNotes',
                title: `${_.startCase(_.toLower(name))} - ${capitalize(stage)} #${orderData?.order_no}`,
                reqParam: {[details.key]: details.widgetId, type: "internal" },
                maxWidth: 'lg',
                showDialogActions: false,
                hideDialogActions: true,
                showHeader: false,
                getNotesData: true,
              },
              field: 'orderDialog',
              stage
            })
          );
          break;
        }
      case 'VIEW_IN PRODUCTION':
      case 'VIEW_ORDER':
      case 'VIEW_QUOTE':
      case 'VIEW_RFQ':
      case 'VIEW_RFD':
      case 'VIEW_PAYMENT':
        if ((!isManage  && !isVasTeam(user.role)) || ['VIEW_PAYMENT'].includes(id))
          dispatch(getEcomWidgetsOrderItems({ [key]: orderData.id, stage })).then(
            (data) => {
              if (data && data.payload) {
                // setOrderItems(data.payload);
                dispatch(
                  openViewOrderDialog({
                    completeOrderData: orderData,
                    data: data.payload,
                    param: {
                      name: id === 'VIEW_PAYMENT' ? 'payment' : 'viewOrder',
                      type: 'View',
                      title: id === 'VIEW_PAYMENT' ? 'Payment History' : `View ${capitalize(getTitle())} Items`,
                      isSupplierInvoice: type === 'supplier-invoices' || type === 'Supplier Invoice',
                      // showDialogActions: !isManage ? true : null,
                      loadOrders,
                    },
                    stage,
                  })
                );
              }
            }
          );
        break;
      case 'REVIEW_ORDER':
        setLoading(true);
        dispatch(getEcomWidgetsOrderItems({ [key]: orderData.id, stage }))
        .then((data) => {
          if(data && data.payload) {
            if(isCustomer(user.role) && (stage === "approval" || stage === "order")) {
              showConfirmationDialog(dispatch, {
                title: name,
                message: 'Do you want to update "Reference/Decedent" information?',
                displayCancelBtn: 'yes',
                actionName: 'Yes',
                cancelActionName: 'No',
                onActionBtnClick: (selectionType) => {
                  if(selectionType !== 'close') {
                    reviewOrder(data, true);
                  }else{
                    reviewOrder(data);
                  }
                },
              })
            } else {
              reviewOrder(data);
            }
          }
        })
        .finally(() => {
          setLoading(false);
        });
        break;
      case 'REVIEW_QUOTE':
        setLoading(true);
        dispatch(getEcomWidgetsOrderItems({ [key]: orderData.id, stage })).then(
          (data) => {
            if (data && data.payload) {
              dispatch(
                openViewOrderDialog({
                  completeOrderData: orderData,
                  data: data.payload,
                  param: {
                    name: 'Review Quote',
                    type: 'View',
                    title: name,
                    showDialogActions: true,
                    hideDialogActions: true,
                    loadOrders,
                  },
                  stage,
                })
              );
              setLoading(false);
            }
          }
        );
        break;
      case 'CONVERT_TO_ORDER':
        dispatch(getEcomWidgetsOrderItems({ [key]: orderId, stage })).then((data) => {
          if (data && data.payload) {
            dispatch(
              openViewOrderDialog({
                completeOrderData: orderData,
                data: data.payload,
                param: {
                  name,
                  type: 'approve',
                  title: name,
                  submitButtonName: name,
                  toStatusCode,
                  onSubmit: () => {
                    dispatch(convertToOrder({ id: orderId, to_status_id: toStatusId }))
                      .unwrap()
                      .then(loadOrders)
                  },
                },
                stage,
              }))
          }
        });
        break;
      case 'RE_ALLOCATION':
        dispatch(
          openReallocationDialog({
            param: {
              name: 'reallocation',
              title: 'Re Allocation',
              submitButtonName: 'Submit',
              selectedFrom: orderData.id,
              loadOrdersFun: loadOrders,
            },
            stage
          })
        );
        break;
      case 'CONFIRM_ORDER':
        dispatch(
          openViewOrderDialog({
            completeOrderData: orderData,
            data: {
              id: orderId,
              action: 'status',
              status: 'Confirmed',
              order_no: orderData.order_no
            },
            param: {
              name: 'confirm',
              title: 'Confirm Order',
              submitButtonName: 'Confirm Order',
              loadOrdersFun: loadOrders,
              successMessage: 'Order status has been updated successfully',
            },
            field: 'orderDialog',
            stage
          }),
          true
        );
        break;
      case 'SEND_TO_SUPPLIER':
        setLoading(false);
        dispatch(getEcomWidgetsOrderItems({ oid: orderData.id, stage })).then(data => {
          if (checkData(data.payload)) {
            if (data && data.payload) {
              dispatch(
                openViewOrderDialog({
                  completeOrderData: orderData,
                  data: data.payload,
                  param: {
                    id: orderData.id,
                    name: 'send to supplier',
                    type: 'View',
                    title: name,
                    submitButtonName: name,
                    loadOrdersFun: loadOrders,
                    action: name
                  },
                  stage
                }))
            }
          } else {
            dispatch(showMessage({
              message: 'Products related fields are missing Please fill in before sending to supplier',
              variant: 'error',
              autoHideDuration: null,
              anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
              },
            }))
          }
        })
          .finally(() => {
            setLoading(false);
          });
        if (workFlowAction.includes(name)) {
          dispatch(getSentToSuppliers(orderData.id));
          const index = workFlowAction.indexOf(name)
          const params = { type: paramForSupplier[index] }
          dispatch(getSuppliers({ suppliers: orderData.suppliers || [], params }));
        }
        break;
      case 'CHOOSE_SUPPLIER':
        dispatch(
          openChooseSupplierDialog({
            param: orderData.id,
            completeOrderData: orderData,
            name,
            status: orderData.status.name,
            stage,
            loadOrdersFun: loadOrders,
          })
        );
        break;
      case 'CREATE_VAS_ORDER':
      case 'CREATE_SUPPLIER_ORDER':
        // We have two different popup in this case
        // Scenario 1. We are going to select Supplier in this popup
        // Scenario 2. Supplier is already selected, We are just going to change the supplier/data/proceed
        setLoading(true);
        // Based on showDialog API response, open the popup
        dispatch(showDialog({ order_id: orderData.id, dialog_name:"Inventory Dialog"}))
          .then((response) => {
            const showInventoryDialog = response?.payload?.inventory_dialog;
            setLoading(false);
            if(showInventoryDialog === true) {
              // Scenario 1. We are going to select Supplier in this popup
              dispatch(openProductDialog({
                param: {
                  name: 'supplierOrderDirectShipment',
                  title: name,
                  orderNo: orderData.id,
                  stage,
                  loadOrdersFun: loadOrders,
                  loadProducts: loadOrders,
                  action: name,
                  editSupplierOrder: orderData.edit_supplier_order ?? true,
                  // added !original.edit_supplier_order to not show confirmation dialog for back order
                  // added !original.is_drawing_order condition to not open drawing required confirmation dialog again
                  showDrawingConfirmation: id === 'CREATE_SUPPLIER_ORDER' && !orderData.edit_supplier_order && !orderData.is_drawing_order,
                  toStatusCode,
                },
              }))
            }
            if(showInventoryDialog === false) {
              // Scenario 2. Supplier is already selected, We are just going to change the supplier/data/proceed
              dispatch(
                openChooseSupplierDialog({
                  param: orderData.id,
                  completeOrderData: orderData,
                  name: "Create Supplier Order",
                  status: orderData.status.name,
                  stage,
                  loadOrdersFun: loadOrders,
                  // added !original.is_drawing_order condition to not open drawing required confirmation dialog again
                  addOnParam : { isCreateSupplierOrder: true, showDrawingConfirmation: (id === 'CREATE_SUPPLIER_ORDER' && !orderData.is_drawing_order), toStatusCode},
                })
              );
            }
          })
        break;
      case 'VIEW_SHIPPING_INFO':
      case 'CREATE_SHIPPING':
        dispatch(
          openSupplierShippingDialog({
            param: orderData.id,
            completeOrderData: orderData,
            type: id === 'VIEW_SHIPPING_INFO' ? 'view' : 'create',
          })
        );
        break;
      case 'SEND_FOR_ORDER_APPROVAL':
      case 'REJECT_DRAWING':
      case 'REJECT_DRAWING_ORDER':
      case 'REJECT':
      case 'REQUEST_REVISION_FOR_DRAWING':
      case 'REQUEST_REVISION_FOR_DRAWING_ORDER':
      case 'APPROVE_DRAWING':
      case 'APPROVE_DRAWING_ORDER':
      case 'SEND_FOR_DRAWING_APPROVAL':
      case 'SEND_ORDER_FOR_DRAWING_APPROVAL':
      case 'SEND_FOR_PROOF_APPROVAL':
      case 'MAKE_IN_PROGRESS':
      case 'RECEIVE_ORDER':
      case 'CANCEL_INVOICE':
      case 'SEND_REMINDER':
      case 'RFQ_REMINDER':
      case 'SEND_PRICE_APPROVAL_FOR_VAS':
      case 'APPROVE_VAS_PRICE':
      case 'MAKE_SHIPMENT':
      case 'REQUEST_REVISION_FOR_VAS_PRICE':
        setLoading(true);
        dispatch(getEcomWidgetsOrderItems({ [key]: orderId, stage })).then((data) => {
          let submitButtonName = name;
          if (name === "Review VAS Price") {
            submitButtonName = "Send Price Approval for VAS"
          }
          if (name === 'Receive Order') {
            submitButtonName = 'Order Receive'
          }
          if (data && data.payload) {
            dispatch(
              openViewOrderDialog({
                completeOrderData: orderData,
                data: data.payload,
                param: {
                  name,
                  type: 'approve',
                  title: name,
                  submitButtonName,
                  toStatusCode,
                  is_proof_approval: id === 'SEND_PRICE_APPROVAL_FOR_VAS' ? false : orderData.is_proof_approval,
                  onSubmit: (formData, code) => confirmation(toStatusCode, id, formData, code),
                  // PGSS-5499: the Approve (internal direct approve) button beside the submit. It was set
                  // only in the STATUS_UPDATE branch below, which Review VAS Price never reaches -- its id
                  // lands here -- so the Dashboard popup lacked the button the Orders page shows.
                  showApproveButton: id === 'SEND_PRICE_APPROVAL_FOR_VAS',
                  showPriceField: id !== 'MAKE_IN_PROGRESS',
                  sendFormValue: ['SEND_PRICE_APPROVAL_FOR_VAS', 'SEND_FOR_ORDER_APPROVAL'].includes(id),
                  resetFormData: getApprovalResetData(data.payload, ['SEND_PRICE_APPROVAL_FOR_VAS', 'MAKE_IN_PROGRESS'].includes(id)),
                  resetForm: name !== 'Receive Order',
                  actionName: id,
                  showAttachment: ['SEND_FOR_ORDER_APPROVAL', 'SEND_FOR_PROOF_APPROVAL', 'SEND_FOR_DRAWING_APPROVAL', 'MAKE_IN_PROGRESS'].includes(id),
                  showNameField: ['SEND_ORDER_FOR_DRAWING_APPROVAL', 'APPROVE_DRAWING_ORDER', 'REJECT_DRAWING_ORDER', 'REQUEST_REVISION_FOR_DRAWING_ORDER'].includes(id),
                },
                stage,
              }))
          }
        })
          .finally(() => {
            setLoading(false);
          });
        break;
      case 'STATUS_UPDATE':
        dispatch(getEcomWidgetsOrderItems({ [key]: orderId, stage })).then((data) => {
          if (data && data.payload && stage !== 'rfq' && isManage) {
            dispatch(
              openViewOrderDialog({
                completeOrderData: orderData,
                data: data.payload,
                param: {
                  name,
                  type: 'approve',
                  title: name,
                  submitButtonName: name === "Review VAS Price" ? "Send Price Approval for VAS" : name,
                  toStatusCode,
                  onSubmit: (formData, code) => confirmation(toStatusCode, id, formData, code),
                  showPriceField: true,
                  sendFormValue: id === 'SEND_PRICE_APPROVAL_FOR_VAS',
                  resetFormData: getApprovalResetData(data.payload, id === "SEND_PRICE_APPROVAL_FOR_VAS"),
                  resetForm: true,
                  showAttachment: ['SEND_FOR_ORDER_APPROVAL', 'SEND_FOR_PROOF_APPROVAL', 'SEND_FOR_DRAWING_APPROVAL', 'MAKE_IN_PROGRESS'].includes(id),
                },
                stage,
              }))
          }
        });
        break;
      case 'UPLOAD_DOCUMENT':
        dispatch(getShipmentInfo({ id: orderId })).then((data) => {
          if (data && data.payload) {
            dispatch(
              openViewOrderDialog({
                completeOrderData: orderData,
                data: data.payload,
                param: {
                  name,
                  type: 'approve',
                  title: name,
                  submitButtonName: name,
                  toStatusCode,
                  onSubmit: (formData, code, approvalPayload) => confirmation(toStatusCode, id, formData, code, approvalPayload),
                  showPriceField: true,
                  isApproval: orderData.is_approval_type,
                  documentApproval: true
                },
                stage,
              }))
          }
        });
        break;
      case 'REJECT_QUOTE':
        dispatch(getEcomWidgetsOrderItems({ [key]: orderId, stage })).then(
          (data) => {
            if (data && data.payload) {
              dispatch(
                openViewOrderDialog({
                  completeOrderData: orderData,
                  data: data.payload,
                  param: {
                    name: 'rejectQuote',
                    title: name,
                    successMessage: 'Your note has been sent successfully',
                    submitButtonName: name,
                    onSubmit: ({ note }) => {
                      confirmation(toStatusCode, id, { note })
                    }
                  },
                  field: 'orderDialog',
                  stage
                })
              );
            }
          }
        );
        break;
      case 'MAKE_PAYMENT':
        dispatch(
          openViewOrderDialog({
            completeOrderData: orderData,
            data: order,
            field: 'orderDialog',
            param: {
              name: 'payment',
              title: 'Add Payment',
              successMessage: 'Success',
              maxWidth: 'md',
              loadOrdersFun: loadOrders,
              isSupplierInvoice: type === 'supplier-invoices' || type === 'Supplier Invoice',
            },
            stage,
          })
        );
        break;
      case 'MAKE_ADVANCE_PAYMENT':
        setLoading(true);
        dispatch(getAdvancePayment(order.id))
          .unwrap()
          .then((response) => {
            setLoading(false);
            dispatch(
              openViewOrderDialog({
                completeOrderData: orderData,
                data: { ...order, advance_payment_data: response },
                field: 'orderDialog',
                param: {
                  name: 'payment',
                  paymentType: 'advance',
                  title: 'Add Advance Payment',
                  successMessage: 'Success',
                  maxWidth: 'md',
                  isSupplierInvoice: type === 'supplier-invoices' || type === 'Supplier Invoice',

                },
                stage,
              })
            );
          });
        break;
      case 'VIEW_INVOICE':
        setLoading(true);
        dispatch(getBriefInvoiceDetails({ id: orderData.id }))
          .unwrap()
          .then((payloadData) => {
            dispatch(
              openViewOrderDialog({
                completeOrderData: orderData,
                data: { ...orderData, ...payloadData, id: orderData.id },
                field: 'orderDialog',
                param: {
                  name: 'invoice',
                  title: 'Invoice Details',
                  maxWidth: payloadData?.discrepancy?.warning_active ? 'md' : undefined,
                  isSupplierInvoice: type === 'supplier-invoices' || type === 'Supplier Invoice',
                },
                stage,
              })
            );
          })
          .catch(() => {
            dispatchMessage(dispatch, 'Unable to load invoice details', 'error');
          })
          .finally(() => setLoading(false));
        break;
      case 'STATUS_CHANGE':
        dispatch(
          openViewOrderDialog({
            completeOrderData: orderData,
            data: order,
            field: 'orderDialog',
            param: {
              name: 'status',
              title: 'Update Status',
              loadOrdersFun: loadOrders
            },
            stage
          })
        );
        break;
      case 'CREATE_DIRECT_SHIPMENT_SUPPLIER_ORDER':
        dispatch(
          openProductDialog({
            param: {
              name: 'supplierOrderDirectShipment',
              title: 'Create Supplier Order',
              orderNo: orderData.id,
              loadProducts: loadOrders,
              stage,
              action: name,
              editSupplierOrder: orderData.edit_supplier_order ?? true
            },
          })
        );
        break;
      case 'EXPORT_SHIPMENT':
        downloadFile({ params: { id: orderId }, endPoint: '/api/exportShipment' })
          .then(() => dispatch(showMessage({ type: 'success', message: 'File downloaded successfully' })))
          .catch(() => dispatch(showMessage({ type: 'error', message: 'Failed to download' })))
        break;
      case 'EXPORT_SHIPMENT_WITH_PRICE':
        dispatch(openViewOrderDialog({
          completeOrderData: orderData,
          data: { id: orderId },
          param: {
            name: '',
            title: name,
            submitButtonName: name,
            loadOrdersFun: loadOrders,
            hideDialogActions: true,
            additionalButton: additionalButton()
          },
          field: 'orderDialog',
          stage,
        }))
        break;
      case 'EXPORT_INVOICE_CUSTOMER':
        downloadFile({ params: { id: orderId, }, endPoint: '/api/exportInvoice' })
          .then(() => dispatch(showMessage({ type: 'success', message: 'File downloaded successfully' })))
          .catch(() => dispatch(showMessage({ type: 'error', message: 'Failed to download' })))
        break;
      case 'COMPLETE_AND_SHIP':
        dispatch(openViewOrderDialog({
          completeOrderData: orderData,
          data: { id: orderId, ...orderData },
          param: {
            name: 'complete_shipment',
            title: name,
            successMessage: 'Completed And Shipped',
            submitButtonName: name,
            loadOrdersFun: loadOrders,
            maxWidth: 'md'
          },
          field: 'orderDialog',
          stage
        }))
        break;
      case 'GENERATE_INVOICE':
        dispatch(openViewOrderDialog({
          completeOrderData: orderData,
          data: { id: orderId },
          param: {
            name: 'generate_invoice',
            title: name,
            successMessage: 'Invoice has been generated',
            submitButtonName: name,
            loadOrdersFun: loadOrders,
          },
          field: 'orderDialog',
          stage
        }))
        break;
      case "REQUEST_VAS":
        showConfirmationDialog(dispatch, {
          title: name,
          message:
            "Do you want the order to be sent to the designer for VAS proofing?",
          displayCancelBtn: "yes",
          cancelActionName: "No",
          actionName: "Yes",
          onActionBtnClick: (selectionType) => {
            if(selectionType !== 'close') {
              dispatch(
                updateOrder({
                  id: orderData.id,
                  to_statuses_type_id: toStatusCode,
                  updateStatus: "yes",
                })
              ).then((res) => {
                if (!res.error) {
                  dispatch(
                    showMessage({
                      message:
                        "The order has been successfully sent to the designer for VAS proofing",
                      type: "success",
                    })
                  );
                  if (loadOrders) {
                    loadOrders();
                  }
                }
              });
            }
          },
        });
        break;
      case "VAS_IN_PROGRESS":
        showConfirmationDialog(dispatch, {
            title: name,
            message: "Do you want the change status to in progress?",
            displayCancelBtn: "yes",
            cancelActionName: "No",
            actionName: "Yes",
            onActionBtnClick: (selectionType) => {
              if(selectionType !== 'close') {
                dispatch(
                  updateOrder({
                    id: orderData.id,
                    to_statuses_type_id: toStatusCode,
                    updateStatus: "yes",
                  })
                ).then((res) => {
                  if (!res.error) {
                    dispatch(
                      showMessage({
                        message: "The order status has been changed successfully",
                        type: "success",
                      })
                    );
                    if (loadOrders) {
                      loadOrders();
                    }
                  }
                });
              }
            },
          });
        break;
      case "ADD_TO_CONTAINER":
        setLoading(true);
        dispatch(getOpenContainers({ order_id: orderData?.id })).then(
          (response) => {
            setLoading(false);
            if (!response.error) {
              const data = response?.payload?.containers;
              dispatch(
                openViewOrderDialog({
                  completeOrderData: orderData,
                  data,
                  param: {
                    name: "add_to_container",
                    title: name,
                    successMessage: "Order assigned to container successfully",
                    submitButtonName: name,
                    loadOrdersFun: loadOrders,
                    maxWidth: "lg",
                    hideDialogActions: true,
                  },
                  field: 'orderDialog',
                  stage,
                })
              );
            } else {
              throw new Error("Failed to load");
            }
          }
        );
        break;
      
      case 'QUICK_EDIT_SHIPMENT':
         dispatch(openViewOrderDialog({
          completeOrderData: orderData,
          data: { id: orderId, ...orderData },
          param: {
            name: 'quick_edit_shipment',
            title: name,
            successMessage: 'Shipment updated successfully',
            submitButtonName: "Save",
            loadOrdersFun: loadOrders,
            maxWidth: 'md'
          },
          field: 'orderDialog',
          stage
        }))
        break;
      default:
        break;
    }

  };

  const pathFunction = (uiId) => {
    switch (uiId) {
      case 'VIEW_ORDER':
        return `/${stage}s/${order.id}?type=view`;
      case 'EDIT':
      case 'EDIT_RFQ':
      case 'EDIT_ORDER':
      case 'EDIT_QUOTE':
      case 'VIEW_QUOTE':
        return `/${stage}s/${order.id}`;
      case 'VIEW_SUPPLIER_INVOICE':
        return `/supplier-invoices?show_suppier_invoice=true&stage=invoice&customer_invoice_id=${order.id}`
      case 'VIEW_RFQ':
        if (isManage) {
          return `/rfq/${order.id}`
        }
        return ''
      case 'REVISE_QUOTE':
        if (isManage) {
          return `/${stage}s/${order.id}?type=revise-quote`
        }
        return ''
      case 'REVIEW_NOTE': {
        // PGSS-5441: the mapping lives in noteRedirect.js so it can be tested. It used to default
        // to `${stage}s`, which produced /fulfilleds/ and /in-productions/ -- neither route exists,
        // so Send Message from the dashboard opened the 404 page.
        let { title, redirectionType } = (isCustomer(user.role) || isSupplier(user.role))
            && !['rfq', 'quote'].includes(stage)
          ? getNoteRedirect(stage, isCustomer(user.role))
          : { title: '', redirectionType: `${stage}s` };
        if (redirectionType === 'rfqs') {
          if (isCustomer(user.role) || isSupplier(user.role)) {
            redirectionType = 'rfqs'
          } else {
            redirectionType = 'rfq'
          }
        }
        if (stage === 'order' && order?.status?.title === 'proof' && isCustomer(user.role)) {
          redirectionType = 'awaiting-approval'
        }
        return `/${redirectionType}/${order.id}?type=view&tab=6&title=${title}`
      }
      case 'CONVERT_TO_QUOTE':
        if (['admin', 'staff', 'sales'].includes(user.role)) return `/rfqs/admin-quotes/${order.id}?type=convert-to-quote`
        return `/rfqs/supplier-quotes/${order.id}`;
      case 'CONVERT_TO_PROOF':
        return `/rfd/supplier-quotes/${order.id}`
      case 'SHIPMENT_PRINT':
        return `/shipments/shippingLabel/${orderId}`;
      case 'PRINT_PRODUCTION':
        return `/shipments/printProduction/${orderId}`;
      case 'EDIT_SHIPMENT':
        return `/shipments/${orderId}`
      case 'STATUS_UPDATE':
        if (isManage)
          return `/${stage}s/${order.id}?type=in-review`;
        return ''
      case 'SUBMIT_VAS_PROOF':
          return `/vas/${order.id}/proof`;
      case "VAS_PROOF_INPROGRESS":
        return `/vas/${order.id}/check-proof`;   
      case "REQUEST_INFORMATION":
        return `/vas/${order.id}/check-proof`;       
      case 'REVIEW_PROOF':
        return `/vas/${order.id}/review`;
      case 'READY_FOR_PLOTTING':
      case 'IN_SANDBLASTING':
      case 'IN_LASER_ETCHING':
      case 'READY_SEND_FOR_VAS_APPROVAL':
        return `/vas/${order.id}/vas-production`
      case 'REVIEW_VAS':
        return `/vas/${order.id}/production-review`;
      case 'ATTACH_DRAWING':
        return `/drawing/${order.id}/request`;
      case 'UPLOAD_IMAGE':
        return `/shipments/uploadProductImages/${order.shipment_id}`;
      case 'APPROVE_PRODUCT_IMAGE':
        return `/shipments/reviewProductImages/${order.shipment_id}`; 
      case 'REVISE_PRODUCT_IMAGE':
        return `/shipments/reviewProductImages/${order.shipment_id}`; 
      case 'EDIT_SUPPLIER_QUOTE':
        if (user.role === 'supplier') return `/rfqs/supplier-quotes/${order.id}`; 
        return ''; 
      default:
        return '';
    }
  };

  const getRoute = (path, uiId) => {
    if (isManage && lowerCase(uiId).includes('view') && !['REVIEW_NOTE', 'VIEW_SUPPLIER_INVOICE', 'VIEW_ORDER', 'REVIEW_PROOF', 'REVIEW_VAS'].includes(uiId))
      return `${path}?type=view`
    return path
  }

  const menuObj = {
    handleClick,
    pathFunction,
    allowActions,
    getRoute,
    closeDialog,
    loadOrders,
    closeViewOrderDialog,
  }

  // PGSS-5453: the popup's own filter -- it is only reached from the popupButtons branches.
  // Exempting a manage user from it is how the View Details popup offered "View Order" for the
  // order it was already showing.
  // `VIEW_${upperCase(getTitle())}` is this list's own default view action -- the same id
  // defaultAction is built with -- so the invoice list drops VIEW_INVOICE in its own popup while
  // an order keeps it.
  const checkShow = (uiId) => !isViewAction(uiId, `VIEW_${upperCase(getTitle())}`);

  const showActions = (id) => {
    switch (id) {
      case 'UPDATE_INVOICE':
        return ['DS', 'Direct Shipment', 'DP', 'Direct Pickup'].includes(orderData?.order_type);
      case 'REVIEW_INVOICE_DISCREPANCY':
        return true;
      case 'VIEW_SUPPLIER_INVOICE':
        return !orderData.is_inventory_invoice
      case 'SEND_FOR_PROOF_APPROVAL':
        return orderData.is_proof_approval
      case 'SEND_FOR_DRAWING_APPROVAL':
        return orderData.is_drawing_approval
      case 'REJECT_PROOF':
      case 'REQUEST_REVISION_FOR_PROOF':
      case 'APPROVE_PROOF':
      case 'APPROVE_VAS':
      case 'REQUEST_REVISION_FOR_VAS':
      case 'REJECT_VAS':
            return false;
      case 'APPROVE_VAS_PRICE':
      case 'APPROVE_DRAWING':
      case 'REQUEST_REVISION_FOR_VAS_PRICE':
      case 'REQUEST_REVISION_FOR_DRAWING':
      case 'REJECT':
      case 'REJECT_DRAWING':
        // PGSS-5453: see OrdersRowActions -- a customer approves from a popup, never from the
        // row, and `popupButtons` is that test. `approveProof` only says the dialog was opened
        // under stage 'order' or 'quote', which the customer's own approval list is not.
        return isCustomer(user.role) ? Boolean(approveProof) || popupButtons : true
      case 'APPROVE_DRAWING_ORDER':
      case 'REQUEST_REVISION_FOR_DRAWING_ORDER':
      case 'REJECT_DRAWING_ORDER':
      case 'SEND_ORDER_FOR_DRAWING_APPROVAL': // Send supplier submitted drawing to customer approval.
        // Added SEND_ORDER_FOR_DRAWING_APPROVAL here so it will display only in the popup not in the table row
        return popupButtons;
      case 'CREATE_VAS_ORDER':
        if (order.is_vas_order && !order.is_proof_approval)
          return false
        if (!order.is_vas_order && order.is_proof_approval)
          return false
        return true
      case 'GENERATE_INVOICE':
        return order.is_invoiced
      case 'UPLOAD_DOCUMENT':
        return order.is_approval_type
      case 'EXPORT_INVOICE_CUSTOMER':
        if (user.role === "customer") return true
        return false
      case 'REJECT_QUOTE':
      case 'STATUS_UPDATE':
        if (isCustomer(user.role)) {
          return approveProof
        }
        // PGSS-5453: `showRejectQuote`, not `!popupButtons`. See OrdersRowActions -- a manage
        // user approves, rejects or revises a quote from the Review Quote popup, and
        // `popupButtons` is true in every popup, not just that one.
        if (isManage && stage === "quote" && !showRejectQuote) {
          return false
        }
        return true
      case 'REQUEST_REVISION_FOR_QUOTE':
        if (isCustomer(user.role)) {
          return approveProof;
        }
        if (isManage && stage === "quote" && !showRejectQuote) {
          return false;
        }
        return true;
      case "CHOOSE_SUPPLIER":
        if (!checkNullOrUndefined(orderData.replied_quote_count) && Number(orderData.replied_quote_count <= 0)) {
          return false;
        }
        return true;
      case 'RFQ_REMINDER':
        return (
          !checkNullOrUndefined(orderData.replied_quote_count) &&
          !checkNullOrUndefined(orderData.sent_to_supplier_count) &&
          Number(orderData.sent_to_supplier_count) > 0 &&
          Number(orderData.replied_quote_count) < Number(orderData.sent_to_supplier_count)
        );
      case 'REVIEW_ORDER':
      case 'REVIEW_DRAWING':
      case 'REVIEW_DRAWING_ORDER':
        // Row only: inside a popup the approval actions themselves are offered instead of a
        // second route to the same dialog.
        return !popupButtons;
      case 'EDIT_SUPPLIER_QUOTE':
        return orderData.show_edit_quote_icon === true;
      default:
        return true;
    }
  }

  const showDefaultAction = () => {
    switch (order.status.name) {
      case 'Confirmed':
        if (isCustomer(user.role)) {
          return false;
        }
        break;
      default:
        return true;
    }
    return true
  };

  // PGSS-5453: built by fixed index below, so it carries `undefined` holes whenever the configured
  // set is shorter than those indices assume -- and every consumer destructures each entry.
  let rearrangedActions;

  if (actions) {
    // PGSS-5501: 'approval' is /awaiting-approval -- the same orders under another stage name. Left
    // to the catch-all below, the popup would move the first two actions (Approve, Request
    // Revision) to the end once those actions render through the approval branch.
    if (stage === 'order' || stage === 'approval') {
      if (isReviewActions) {
        rearrangedActions = [actions[1], actions[2], actions[3]]
      } else {
        rearrangedActions = actions;
      }
    } else if (stage === 'quote') {
      if (isCustomer(user.role)) {
        rearrangedActions = actions
      }
      else if (showRejectQuote) {
        // actions[4] has Reject Quote.
        rearrangedActions = [actions[1], actions[2], actions[3], actions[4]]
      }
      else if (popupButtons && isManage) {
        rearrangedActions = [actions[1], actions[2], actions[3]]
      }
      else rearrangedActions = [...actions.slice(1), actions[0]];
    } else {
      rearrangedActions = [...actions.slice(2), ...actions.slice(0, 2)];
    }
    rearrangedActions = rearrangedActions.filter(Boolean);
  }

  const getDetails = () => {
    let stageValue = { id: '', key: '', widgetId: '' };
    switch (stage) {
      case 'invoice':
        stageValue = {
          id: orderData.invoice_no,
          key: 'invoice_id',
          widgetId: orderData.id
        }
        break;
      case 'container':
      case 'in-production':
        stageValue = {
          id: orderData.container_number,
          key: 'shipment_id',
          widgetId: orderData.shipment_id
        }
        break;
      default:
        stageValue = {
          id: orderData.order_no,
          key: 'oid',
          widgetId: orderData.id
        }
    }

    return stageValue;
  };

  const getStageTitle = (isTooltipTitle) => {
    const stageData = stage
    switch (stageData) {
      case 'fulfilled':
      case 'confirmed':
      case 'order':
        return `View Order Details`;
      case 'quote':
        return `View Quote Details`;
      case 'rfq':
        return `View Rfq Details`;
      case 'invoice':
        return `View Invoice`;
      case 'approval':
        return `View Approval Items`;
      case 'shipment':
        return 'View Shipment';
      case 'container':
        return 'View Container Shipment'
      case 'in-production':
        return 'View In-production'
      default:
        return "";
    }
  }

  const handleViewOrder = () => {
    dispatch(getEcomWidgetsOrderItems({ [getDetails().key]: getDetails().widgetId, stage: stage === 'container' ? 'in-production' : stage, invoiceId: true })).then((data) => {
      if (data && data.payload) {
        // setOrderItems(data.payload);
        dispatch(
          openViewOrderDialog({
            completeOrderData: orderData,
            stage: stage === 'container' ? 'in-production' : stage,
            data: stage === 'invoice' ? data.payload.invoice : data.payload,
            param: {
              name: 'viewOrder',
              type: 'View',
              title: getStageTitle(false),
              showDialogActions: true,
              is_vas_order: orderData?.is_vas_order,
              packingSlips: data.payload?.packing_slips || [],
              supplierInvoices: data.payload?.supplier_invoices || [],
              isSupplierInvoice: type === 'supplier-invoices' || type === 'Supplier Invoice',
            },
          })
        );
      }
    })
  }

  const handleHideAction = (name) => {
    if (name === 'Revisions To Supplier' && orderData?.suppliers?.length === 0) return true
    return false
  }

  /**
   * Popup that is opened from Dialog button click(Popop inside another popup)
   * This function create additiona param that will be send to popup
   */
  const getAdditionParamForDialogButtons = (uiId) => {
    switch (uiId) {
      case 'REQUEST_REVISION_FOR_DRAWING_ORDER':{
          // If Admin/staff Request Revision for Drawing then pass note field as revision_note
          if(!isCustomer(user.role) && !isSupplier(user.role))
            return {
              showAutoNote: true, // Set this field for schema creation and display AutoNote field section in NoteFormCOntent
              noteFieldName: "revision_note", // Set this field for note field_name that will be sent to BE
              noteFieldLabelName: "Revision Comments", // Set this field for display Label name
            }
          return {};
        }
      default:
        return {};
    }
  }

  // PGSS-5447: an archived record is a closed book -- viewable, not actionable. The list already
  // applied this rule; the details popup never had it, so opening an archived RFQ, quote or order
  // offered the full action set.
  //
  // Placed ABOVE the renderActions branch, not below it. Below, any caller supplying its own
  // renderer -- the customer inbox does -- returns before the guard is reached and keeps every
  // action on an archived record. A guard one path can walk past is the shape of the bug this
  // whole change is fixing.
  if (isArchivedView(typeof window !== 'undefined' ? window.location.search : '')) {
    return null;
  }

  /**
   * PGSS-5453 — the popup's action set, derived from the row's, with one predicate applied to
   * whichever list the branch below renders. See popupActions.js for what the popup used to do
   * instead, and why the row and the popup disagreed.
   */
  const isPopupAction = ({ name, ui_id: uiId }) =>
    !handleHideAction(name) && showActions(uiId) && checkShow(uiId);

  const popupDefaultActions = splitPopupActions(defaultAction, isPopupAction);
  const popupStatusActions = splitPopupActions(actions, isPopupAction);
  const popupApprovalActions = splitPopupActions(rearrangedActions, isPopupAction, maxCount);

  /**
   * The plain popup button: close the dialog, then run the action. Shared by the default-action
   * and configured-action branches, which had drifted into two spellings of the same markup.
   */
  const renderPopupButton = ({
    name,
    icon,
    ui_id: uiId,
    to_statuses_types_code: toStatusCode,
    to_statuses_types_id: toStatusId,
  }) => {
    const asLink = pathFunction(uiId) && allowActions.includes(uiId);

    return (
      <Button
        key={uiId}
        className="mr-5"
        color="secondary"
        variant="contained"
        startIcon={<Icon fontSize="small" sx={{ color: 'white' }}>{icon}</Icon>}
        component={asLink ? Link : undefined}
        to={getRoute(pathFunction(uiId), uiId)}
        state={
          asLink
            ? {
                name,
                ui_id: uiId,
                to_statuses_types_code: toStatusCode,
                to_statuses_types_id: toStatusId,
                status_actions: actions,
              }
            : undefined
        }
        onClick={() =>
          runPopupAction({
            name,
            ui_id: uiId,
            to_statuses_types_code: toStatusCode,
            to_statuses_types_id: toStatusId,
          })
        }
        sx={{ width: 'auto' }}
        disabled={popupActionRunning}
      >
        <span style={{ fontSize: 12 }}>{name}</span>
      </Button>
    );
  };

  /**
   * What an approval action does when the user picks it. Lifted out of the button's onClick so the
   * overflow menu can run it too: an action that does not fit inline must still behave like its
   * button, not fall back to the table's handler.
   */
  const handleApprovalAction = ({ name, ui_id: uiId, to_statuses_types_code: toStatusCode }) => {
    if (['Approve Quote', 'Send for Quote Approval'].includes(name)) {
      const orderDetails = buildSelectedDrawing(selectedImages, listData)
      confirmation(toStatusCode, uiId, { updateStatus: 'yes', order_details: orderDetails })
    }
    else if (['SEND_ORDER_FOR_DRAWING_APPROVAL'].includes(uiId)) {
      // No need to show popup to get notes
      confirmation(toStatusCode, uiId)
    } else if(['DOWNLOAD'].includes(uiId)){
      if(orderId){
        setLoading(true);
        dispatch(downloadOrderPdf(({ id: orderId, stage, orderNo: orderData?.order_no })))
        .finally(() => setLoading(false));
      }
    }
    else if (pathFunction(uiId) && allowActions.includes(uiId)) {
      // PGSS-5691: an action with its own page (Review VAS, Review Proof) only goes there -- its button is a
      // Link. Opening the approval note dialog on top of that page left the page without its order once the
      // dialog closed. Same as from the row.
      dispatch(closeViewOrderDialog());
    }
    else if (name !== 'Edit Quote') {
      dispatch(
        openViewOrderDialog({
          completeOrderData: orderData,
          data: { id: orderId },
          param: {
            name: 'approveActions',
            title: name,
            successMessage: 'Success',
            submitButtonName: 'Submit',
            loadOrdersFun: loadOrders,
            data: {
              uiId,
              toStatusCode,
              extraPayloadData: popupData?.extraPayloadData,
              passExtraPayload: popupData?.passExtraPayload
            },
            ...getAdditionParamForDialogButtons(uiId)
          },
          field: 'orderDialog',
          stage
        })
      );
    }
  };

  /**
   * PGSS-5470 — what a plain View Details popup button (or its overflow entry) does.
   *
   * By default: close the popup and run the row's handler. For the drawing decisions that handler
   * is the wrong one here -- on the row it opens a review of the order with a note box, so from
   * inside the popup the user saw the order details a second time and no document upload. The
   * Review Drawing popup already sends these to the approval dialog; this does the same from the
   * plain popup, which stays open underneath exactly as it does there.
   *
   * Everything else keeps the row's handler, including the actions PGSS-5471 decided keep their
   * review step. `opensApprovalDialogFromPopup` explains why the list is ids, and why so few.
   */
  const runPopupAction = (action) => {
    if (opensApprovalDialogFromPopup(action.ui_id)) {
      handleApprovalAction(action);
      return;
    }
    const firstClick = firstClickPopupAction(action, {
      stage,
      statusCode: order?.status?.system_code,
      isCustomerUser: isCustomer(user.role),
    });
    if (firstClick) {
      runFirstClickPopupAction(action, firstClick);
      return;
    }
    dispatch(closeViewOrderDialog());
    handleClick(action.ui_id, action.to_statuses_types_code, action.name, action.to_statuses_types_id);
  };

  /**
   * PGSS-5471 — run the action straight from View Details. The Orders page copy
   * (OrdersRowActions.runFirstClickPopupAction) explains it; the two must stay in step.
   */
  const runFirstClickPopupAction = (
    { ui_id: uiId, to_statuses_types_code: toStatusCode },
    { input },
  ) => {
    if (popupActionRunning) return;
    let payload = {};
    if (input === 'drawings') {
      payload = { updateStatus: 'yes', order_details: buildSelectedDrawing(selectedImages, listData) };
    } else if (input === 'documents') {
      payload = buildInlineDocumentsPayload(listData, getValues?.());
    }
    setPopupActionRunning(true);
    Promise.resolve(confirmation(toStatusCode, uiId, payload)).finally(() => setPopupActionRunning(false));
  };

  const renderApprovalButton = (action) => {
    const { name, icon, ui_id: uiId } = action;

    return (
      <Button
        key={uiId}
        className='mr-5'
        color="secondary"
        variant="contained"
        startIcon={<Icon fontSize="small" sx={{ color: 'white' }}>{icon}</Icon>}
        component={pathFunction(uiId) && allowActions.includes(uiId) && name !== 'Approve Quote' ? Link : undefined}
        to={getRoute(pathFunction(uiId), uiId)}
        onClick={() => handleApprovalAction(action)}
        sx={{ width: 'auto' }}
        disabled={isSubmitted}
      >
        <span style={{ fontSize: 12 }}>{name}</span>
      </Button>
    );
  };

  if (renderActions) {
    return renderActions({
      actions: rearrangedActions || actions || [],
      // PGSS-5632: the classic row's order and hide rule. `actions` above is the POPUP order (rotated
      // for rfq/quote), which a row-style renderer must not pick its next step from.
      rowActions: actions || [],
      hideAction: handleHideAction,
      handleClick,
      loading,
      pathFunction,
      getRoute,
      allowActions,
      showActions,
    });
  }

  return (
    <div className="flex flex-row">
      <div className="flex items-center">
        {!actions && stage !== "fulfilled" && showDefaultAction() && !isCustomer(user.role) && !isSupplier(user.role) && (
          popupButtons ? (
            <>
              {popupDefaultActions.inline.map(renderPopupButton)}
              {popupDefaultActions.overflow.length > 0 && (
                <MenuActions actions={popupDefaultActions.overflow} obj={menuObj} />
              )}
            </>
          ) : (
            defaultAction.map(({ name, icon, ui_id: uiId, to_statuses_types_code: toStatusCode, to_statuses_types_id: toStatusId }) => {
              if (!showActions(uiId)) return null;
              return (
                <Tooltip key={uiId} title={name}>
                  <IconButton
                    className="py-0 px-2"
                    size="small"
                    onClick={(ev) => handleClick(uiId, toStatusCode, name, toStatusId)}
                    component={pathFunction(uiId) && allowActions.includes(uiId) ? Link : undefined}
                    to={getRoute(pathFunction(uiId), uiId)}
                  >
                    <Icon fontSize="small">{icon}</Icon>
                  </IconButton>
                </Tooltip>

              );
            })
          )
        )}
        {actions && approveProof === undefined && (
          popupButtons ? (
            <>
              {popupStatusActions.inline.map(renderPopupButton)}
              {popupStatusActions.overflow.length > 0 && (
                <MenuActions actions={popupStatusActions.overflow} obj={{ ...menuObj, onSelect: runPopupAction }} />
              )}
            </>
          ) : (
            actions.map(({ name, icon, ui_id: uiId, to_statuses_types_code: toStatusCode, to_statuses_types_id: toStatusId }) => {
              if (handleHideAction(name)) return null
              if (!showActions(uiId)) return null;
              return (
                <Tooltip key={uiId} title={name}>
                  <IconButton
                    className="py-0 px-2"
                    size="small"
                    onClick={(ev) => handleClick(uiId, toStatusCode, name, toStatusId)}
                    component={pathFunction(uiId) && allowActions.includes(uiId) ? Link : undefined}
                    to={getRoute(pathFunction(uiId), uiId)}
                    state={{name, ui_id: uiId, to_statuses_types_code: toStatusCode, to_statuses_types_id: toStatusId, status_actions: actions}}
                  >
                    <Icon fontSize="small">{icon}</Icon>
                  </IconButton>
                </Tooltip>

              );
            })
          )
        )}

        {
          // PGSS-5469: row only. It opens the View Details popup, so inside that popup it re-opened
            // the popup already on screen and appeared to do nothing.
            !popupButtons && actions && approveProof === undefined && orderData?.is_show_drawing_icon && (
            <Tooltip title="View Attached Diagram">
              <IconButton
                className="py-0 px-2"
                size="small"
                onClick={() => handleViewOrder()}
              >
                <Icon fontSize="small">attach_file</Icon>
              </IconButton>
            </Tooltip>
          )
        }

        {loading && (
          <Backdrop open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}

        {actions && approveProof && popupButtons &&
          popupApprovalActions.inline.map(renderApprovalButton)}

        {/* PGSS-5453: the remainder of the SAME filtered list, not `actions.slice(3)`. Indexing
            the raw set here is what let the menu offer actions the status filter had already
            rejected, and drop ones the inline cap had pushed out.
            `onSelect` so an action that overflows still does what its button would have done --
            the menu's own handler is the table's, which is a different dialog. */}
        {actions && approveProof && popupButtons && popupApprovalActions.overflow.length > 0 && (
          <MenuActions
            actions={popupApprovalActions.overflow}
            obj={{ ...menuObj, onSelect: handleApprovalAction }}
          />
        )}


      </div>
    </div>
  );
}

export default OpenOrdersRowAction;
